import $ from 'jquery'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      dragging : false,
      hovering : false,
      originalTitle : '',
      originalACF : null,
      birthday : this.phpTimestamp(),
      updateInterval : null,


      page_w : null,
      page_h : null,
      menu_w : null,
      menu_h : null,
      menuEl : null,
      menuInnerEl : null,
      logs : {
        shrinkHeights : 0,
        shrinkWidths : 0,
      },
      runResize : true,
      resizeComplete : false

    }
  }, // data
  computed : {
    ...mapState(['wpData']),
    isDrinksMenu() {
      return this.$options.name == "DrinksMenu"
    }, // isDrinksMenu
    menuClasses() {
      return {
        'show-menu-overlay' : false,
        dragging : this.dragging
      }
    }, // menuClasses
  },
  mounted() {
    this.menuEl = this.$refs.menu
    this.menuInnerEl = this.$refs.menuInner
    this.maybeRunResize()
  }, // mounted
  watch: {
    runResize(newVal) {
      if( newVal ) {
        this.maybeRunResize()
      }
    }
  }, // watch 
  methods : {
    maybeRunResize() {
      if( this.runResize && parseInt( this.wpData.togo ) && parseInt( this.wpData.print ) ) {
        this.vueComponentResize()
      } else {
        this.$emit('resizeComplete')
      }
    }, // maybeRunResize
    vueComponentResize() {
      console.log('[ resize ] vue resize')
      // let $menuInner = this.$refs.menuContent

      // let sectionHeight = 0
      // this.$refs.sections.forEach( s => { sectionHeight += s.$el.clientHeight } )
      let tooTall = this.menuInnerEl.clientHeight > this.menuEl.clientHeight
      console.log('[ menu height ]', this.menuEl.clientHeight)
      console.log('[ menu-inner height ]', this.menuInnerEl.clientHeight)
      if( tooTall ) {
        console.log('tooTall!!!')
        this.resizeMenu();
      } else {
        this.$emit('resizeComplete')        
      }
    }, // vueComponentResize

   resizeMenu(){
      let $menuWrap = $( this.menuEl )
      let $menuInner = $( this.menuInnerEl )
      let menuObj = this.menu 
      if( $menuWrap.length > 0 ) {
        
        this.page_w = $menuWrap.outerWidth();
        this.page_h = $menuWrap.outerHeight();
        console.log('print-page',{w:this.page_w,h:this.page_h})

        $('#menu-manager-app').css({'justify-content': 'flex-start'});
        $menuWrap.css({'max-width': this.page_w, 'margin':0});

        console.log('resizing')
        this.shrinkMenu( $menuInner, menuObj );

      }  
    }, // resizeMenu()

    shrinkMenu( $menuInner, menuObj ){

      let $menu = $menuInner[0];
      this.menu_w = $menu.offsetWidth;
      this.menu_h = $menu.offsetHeight;

      if( this.menu_h > this.page_h ) {
        console.log(`[ ${menuObj.acf.menu_title} shrink ] shrinking height`)
        this.shrinkHeight()
      }

      if( this.menu_w > this.page_w ) {
        console.log(`[ ${menuObj.acf.menu_title} shrink ] shrinking width`)
        this.shrinkWidth();
      }
      
      this.menu_w = $menu.offsetWidth;
      this.menu_h = $menu.offsetHeight;
      if( this.menu_w > this.page_w || this.menu_h > this.page_h ) {  
      // if( menu_h > page_h ) {
        if( parseFloat( $('html').css('font-size' ) ) > 9 ) {
          setTimeout(() => {
            this.shrinkMenu( $menuInner, menuObj );
          }, 1)
        }
      } else {
        console.log(`[ FINITO ${menuObj.acf.menu_title}  ] She fits!`)
        console.log(this.logs)
        this.$emit('resizeComplete')
        this.resizeComplete = true
        return true;
      }

    }, // shrinkMenu

    shrinkHeight(){
      this.logs.shrinkHeights++;

      this.multiplyCssAtts('html, #menu-manager-app, p','font-size', .99);

      if( this.isDrinksMenu ) {
        this.multiplyCssAtts('.drinks-menu-col','padding-bottom', .90);
        
        // this.multiplyCssAtts('.drinks-menu-col','flex-basis', 1.003, '%');
        this.multiplyCssAtts('.drinks-menu-col','min-width', .95);
      }

      this.multiplyCssAtts('.menus .menu','padding-top', .8);

      // this.multiplyCssAtts('.menu-title','font-size', .99);

      // this.multiplyCssAtts('.section.has-subsections .section-title','font-size', .99);
      
      this.multiplyCssAtts('.menu-col .menu-items .item',['padding-top','padding-bottom'], .99);
      
      this.multiplyCssAtts('.special-icon','background-size', .99, '%');
      this.multiplyCssAtts('.special-icon','left', .9);
      this.multiplyCssAtts('.special-icon','top', .93);

    }, // shrinkHeight

    shrinkWidth(){
      this.logs.shrinkWidths++;

      this.multiplyCssAtts('.menus .menu',['padding-left','padding-right'], .9);

      this.multiplyCssAtts('.menu-inner',['margin-left','margin-right'], .95);
      
      this.multiplyCssAtts('.menu-inner','width', .995);
      if( this.isDrinksMenu ) {
        this.multiplyCssAtts('.drinks-menu-footer','width', .995);
      }
      
      this.multiplyCssAtts('#menu-manager-app','width', .999);
      
    }, // shrinkWidth

    multiplyCssAtts( selector, atts, multiplier, unit ){

      if( $(selector).length == 0 ) {
        // console.log('selector "'+selector+'" not on page');
        return false;
      }

      if( "undefined" === typeof unit ) {
        unit = 'px'
      }

      var newAtts = {};
      // allow passing atts array or string
      if( "object" === typeof atts ) {
        for(var i=0;i<atts.length;i++) {
          var newVal = parseFloat( $(selector).css(atts[i]) ) * multiplier;
          var attr = atts[i];
          newAtts[ attr ] = newVal + unit
          // console.log(selector + ':' + atts[i], newVal);
        }
      } else {
        var newVal = parseFloat( $(selector).css(atts) ) * multiplier;
        newAtts[ atts ] = newVal + unit;
      }
      if( typeof newAtts['font-size'] !== "undefined" ){
        this.$store.commit('UPDATE_MENU_FONT_SIZE', newAtts['font-size'] )  
      }

      $(selector).css(newAtts);
      // $(selector).animate(newAtts, 500);
      
    }, // multiplyCssAtts


  }, // methods
}



// WEBPACK FOOTER //
// ./src/components/Menus/MenuMixin.js